<template>
  <div
    :class="{ 'text-center': !isMobile }"
    data-qa="user_authorization_phone_to_call"
  >
    <div class="text-body-1 text--text mb-4">
      Для подтверждения позвоните нам.
      Вам не придётся ничего говорить: система сама завершит звонок.
    </div>
    <v-btn
      v-if="isMobile"
      block
      class="mb-4"
      elevation="0"
      color="primary"
      :href="`tel:${authPhoneTel}`"
      data-qa="user_authorization_phone_to_call_button"
    >
      Позвонить {{ authPhone }}
    </v-btn>
    <div
      v-else
      class="text-h4 text--text mb-2"
      data-qa="user_authorization_phone_to_call_number"
    >
      {{ authPhone }}
    </div>
    <div class="text-body-1 text--text text-center">
      Звонок бесплатный
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAuthorizationByUserCallContent',
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
  computed: {
    authPhone() {
      return '8 800 707-87-86'
    },
    authPhoneTel() {
      return this.authPhone.replaceAll(/\s|-/g, '')
    },
  },
}
</script>
